import { createAction, props } from '@ngrx/store'
import { ReviewTargetModel, RequestModel } from '@models/index'

export const searchAllReviewTargets = createAction(
    '[Review Targets Page] Search All Review Targets',
    props<{ request: RequestModel }>()
)

export const searchReviewTargetsByLocation = createAction(
    '[Review Targets Page] Search Review Targets By Location',
    props<{ request: RequestModel }>()
)

export const searchAllReviewTargetsByLocation = createAction(
    '[Review Targets Page] Search All Review Targets By Location',
    props<{ request: RequestModel }>()
)

export const searchAllReviewTargetsByLocationSuccess = createAction(
    '[Review Targets Page] Search All Review Targets By Location Success',
    props<{ reviewTargets: ReviewTargetModel[] }>()
)

export const searchReviewTargetsSuccess = createAction(
    '[Review Targets Page] Search Review Targets Success',
    props<{ data: ReviewTargetModel[], total: number }>()
)

export const saveReviewTarget = createAction(
    '[Review Targets Page] Save Review Target',
    props<{ request: RequestModel }>()
)

export const saveReviewTargetByLocation = createAction(
    '[Review Targets Page] Save Review Target By Location',
    props<{ request: RequestModel, showToastMessage: boolean }>()
)

export const saveReviewTargetSuccess = createAction(
    '[Review Targets Page] Save Review Target By Success',
    props<{ reviewTarget: ReviewTargetModel }>()
)

export const deleteReviewTarget = createAction(
    '[Review Targets Page] Delete Review Target',
    props<{ request: RequestModel }>()
)

export const deleteReviewTargetSuccess = createAction(
    '[Review Targets Page] Delete Review Target Success',
    props<{ reviewTargetId: string }>()
)

export const searchAllReviewTargetsByQueryByLocation = createAction(
    '[Review Targets Page] Search All Review Targets By Query By Location',
    props<{ request: RequestModel }>()
)

export const switchAllReviewTargets = createAction(
    '[Review Targets Page] Switch All Review Targets',
    props<{ request: RequestModel }>()
)

export const switchAllReviewTargetsByLocation = createAction(
    '[Review Targets Page] Switch All Review Targets By Location',
    props<{ request: RequestModel }>()
)

export const setSelectedReviewTarget = createAction(
    '[Review Targets Page] Set Selected Review Target',
    props<{ reviewTarget: ReviewTargetModel }>()
)

export const searchReviewSourcesQuerySuccess = createAction(
    '[Review Targets Page] Search Review Sources Query Success',
    props<{ data: ReviewTargetModel[], total: number }>()
)

export const addReviewSourceToLocation = createAction(
    '[Review Targets Page] Add Review Source To Location',
    props<{ request: RequestModel }>()
)

export const addReviewSourceToLocationSuccess = createAction(
    '[Review Targets Page] Add Review Source To Location Success',
    props<{ reviewSource: ReviewTargetModel }>()
)

export const deleteReviewTargetByLocation = createAction(
    '[Review Targets Page] Delete Review Target By Location',
    props<{ request: RequestModel }>()
)

export const reviewTargetError = createAction(
    '[Review Targets Page] Review Target Error',
    props<{ error : string }>()
)

export const searchLocationReviewTargetWithErrorsSuccses = createAction(
    '[Review Targets Page] Search Review Target With Error Success',
    props<{ locationReviewTargetWithErrors: boolean }>()
)

export const searchLocationReviewTargetWithErrors = createAction(
    '[Review Targets Page] Search Review Target With Error',
    props<{ request: RequestModel }>()
)

export const updateGMBReviewTargetByLocation = createAction(
    '[Review Targets Page] Update GMB Review Target To Location',
    props<{ request: RequestModel }>()
)

export const updateGMBReviewTargetByLocationSuccess = createAction(
    '[Review Targets Page] Update GMB Review Target To Location Success',
    props<{ reviewTarget: ReviewTargetModel }>()
)

export const setReviewTargetToIntegrate = createAction(
    '[Review Targets Page] Set Review Target To Integrate',
    props<{ reviewTargetId: string }>()
)

export const setShowRevieTargetLocationFormAfterRedirect = createAction(
    '[Review Targets Page] Set Show Review Target Location Form After Redirect',
    props<{ showForm: boolean }>()
)

export const setUIReviewTargetList = createAction(
    '[Review Targets Page] Set UI Review Target List',
    props<{ list: ReviewTargetModel[] }>()
)

export const updateFacebookReviewTargetByLocation = createAction(
    '[Review Targets Page] Update Facebook Review Target To Location',
    props<{ request: RequestModel }>()
)

export const updateFacebookReviewTargetByLocationSuccess = createAction(
    '[Review Targets Page] Update facebook Review Target To Location Success',
    props<{ reviewTarget: ReviewTargetModel }>()
)

export const disableOrEnabled = createAction(
    '[Review Targets Page] Disable or Enabled',
    props<{ request: RequestModel }>()
)

export const disableOrEnabledSuccess = createAction(
    '[Review Targets Page] Disable or Enabled Success',
    props<{ reviewTarget: ReviewTargetModel }>()
)